import { Button } from 'components/ui/button';
import { buttonStyle } from 'components/buttons/buttonStyle';
import { Dialog, DialogContent } from 'components/ui/dialog';
import ListPickerInput from 'components/forms/inputs/rhf-inputs/ListPickerInput';
import React, { useState } from 'react';
import { t } from 'utils/getTranslations';
import { ModalFooterSimple } from '../ModalFooterSimple.tsx';
import { ModalHeader } from '../ModalHeader.tsx';

interface EmployeePickerModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (selectedEmployeeIds: string[]) => void;
    title: string;
    employeeOptions: { label: string; value: string }[];
}

const EmployeePickerModal: React.FC<EmployeePickerModalProps> = ({
    open,
    onClose,
    onConfirm,
    title,
    employeeOptions,
}) => {
    const [selectedEmployeeIds, setSelectedEmployeeIds] = useState<string[]>([]);

    const handleConfirm = () => {
        onConfirm(selectedEmployeeIds);
        setSelectedEmployeeIds([]);
        onClose();
    };

    const handleCancel = () => {
        setSelectedEmployeeIds([]);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onOpenChange={(nextOpen) => {
                if (!nextOpen) {
                    handleCancel();
                }
            }}
        >
            <DialogContent
                showCloseButton={false}
                className="bg-grey-0 flex max-h-[calc(100dvh-64px)] min-h-[400px] w-[900px] flex-col gap-0 overflow-hidden rounded-[12px] p-0 max-sm:w-full sm:max-w-none"
            >
                <ModalHeader title={t(title)} onCancel={handleCancel} />
                <div className="flex-1 overflow-y-auto px-6 pt-4">
                    <ListPickerInput
                        options={employeeOptions}
                        onListChange={setSelectedEmployeeIds}
                        label="forms.select-employees"
                    />
                </div>
                <ModalFooterSimple
                    buttons={[
                        <Button
                            {...buttonStyle({ variant: 'outlined', color: 'primary' })}
                            key="cancel"
                            onClick={handleCancel}
                        >
                            {t('cancel')}
                        </Button>,
                        <Button
                            {...buttonStyle({ variant: 'contained', color: 'secondary' })}
                            key="confirm"
                            onClick={handleConfirm}
                        >
                            {t('add')}
                        </Button>,
                    ]}
                />
            </DialogContent>
        </Dialog>
    );
};

export default EmployeePickerModal;
